import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  fetchData,
  search,
  closeSlider,
} from "../../../../_actions/sidebarSliderActions";
import { REPLACE_META } from "../../../../_actions/types";
import {
  wsAddLayer,
  wsUpdateLayer,
} from "../../../../_actions/webSocketAction";
import { prepareGifPayload } from "../../../../_utils/common";
import { ImageItem } from "../../../common/statelessView";
import SuperList from "./SuperList";

class GiphyList extends Component {
  render() {
    const { sidebarSlider, story, t } = this.props;
    const { source, loaded, payload, hasMore } = sidebarSlider;

    const childElements = payload.map((giphy) => {
      if (!giphy?.images?.preview_gif?.url) {
        return null;
      }
      const payload = prepareGifPayload(source, giphy, story.contentSize);
      return (
        <div
          key={giphy.id}
          className="item"
          onClick={() => this.addLayerCallback(payload)}
          data-grid-groupkey={giphy.groupKey}
        >
          <ImageItem
            data={payload}
            key={giphy.id}
            url={giphy.images.preview_gif.url}
            alt={giphy.title}
            width={giphy.images.preview_gif.width}
            height={giphy.images.preview_gif.height}
            source={"Giphy"}
            showOverlayInfo={true}
            isUsedInSwiper={false}
          />
        </div>
      );
    });
    return (
      <>
        <SuperList
          list="giphy-gallery"
          loaded={loaded}
          searchPlaceholder={t("search.search_giphy")}
          notFound={t("search.giphy_not_found")}
          errorsView={null}
          hasMore={hasMore}
          loadPage={this.loadPage}
          showRecents
          onClickRecent={this.addLayerCallback}
        >
          {childElements}
        </SuperList>
      </>
    );
  }

  loadPage = (groupKey) => {
    if (!this.props.searchText) {
      this.props.fetchData(this.props.sidebarSlider.gifSource, {
        ...this.props,
        groupKey,
      });
      return;
    }
    this.props.search(
      this.props.sidebarSlider.gifSource,
      this.props.searchText,
      { ...this.props, groupKey }
    );
  };

  addLayer = (data) => {
    this.props.wsAddLayer(this.props.editor.activePage.id, data);
  };

  updateLayer = (data) => {
    const sourceUrl = data.payload.src;
    const layerId = this.props.editor.activeElement.id;

    const message = {
      layer: layerId,
      content: data.content,
      payload: {
        ...data.payload,
        src: sourceUrl,
        userProperty: data?.payload?.userProperty,
      },
    };
    this.props.wsUpdateLayer(message);
  };

  addLayerCallback = (data) => {
    const { action } = this.props.sidebarSlider;
    if (action === REPLACE_META) {
      this.updateLayer(data);
    } /*else if (action === UPDATE_BKG) {
      this.updatePage(data);
    }*/ else {
      this.addLayer(data);
    }
    if (this.props.isMobileView) {
      this.props.closeSlider();
    }
  };
}

GiphyList.propTypes = {
  editor: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  sidebarSlider: PropTypes.object.isRequired,
  pagestore: PropTypes.object.isRequired,
  layerstore: PropTypes.object.isRequired,
  panelType: PropTypes.string.isRequired,
  page: PropTypes.number.isRequired,
  searchText: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  sidebarSlider: state.sidebarSlider,
  errors: state.errors,
  editor: state.editor,
  pagestore: state.pagestore,
  layerstore: state.layerstore,
  panelType: state.sidebarSlider.sliderPanelType,
  page: state.sidebarSlider.page,
  searchText: state.sidebarSlider.searchText,
  story: state.story,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  wsAddLayer: (activePageId, payload) =>
    dispatch(wsAddLayer(activePageId, payload)),
  wsUpdateLayer: (payload) => dispatch(wsUpdateLayer(payload)),
  fetchData: (source, props) => dispatch(fetchData(source, props)),
  search: (source, searchTerm) => dispatch(search(source, searchTerm)),
  closeSlider: () => dispatch(closeSlider()),
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(GiphyList)
);
